import React from 'react';
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField';
import { Field } from 'redux-form';
import MokaDatePicker from 'components/receipt/invoices/RecordPaymentModal/MokaDatePicker';
import styles from '../DetailForm.css';
import {
  alphabeticalAndSomeChar,
  alphabeticalOnly,
  gender,
  inputField,
  maritalStatus,
  numberOnly,
  renderError,
  renderSelectField,
  residenceOwnership,
} from '../utilsForm';

class ModalkuNewPersonalInfoForm extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.capitalForm.is_address_same_as_ktp === 'true') {
      this.props.changeField('is_address_same_as_ktp', true);
    } else if (nextProps.capitalForm.is_address_same_as_ktp === 'false') {
      this.props.changeField('is_address_same_as_ktp', false);
    }
  }

  render() {
    const { businessLocationsState, capitalForm } = this.props;

    return (
      <div className={`col-md-12 col-lg-12`}>
        <div className="col-md-3">
          <label>Personal Information</label>
        </div>
        <div className="col-md-9">
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Full Name
              <red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                component={inputField}
                name="full_name"
                maxLength="255"
                placeholder="Your Full Name"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                className={`form-control ${styles['account-name']}`}
                normalize={alphabeticalOnly()}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="email" className="col-sm-4 col-form-label">
              Email
              <red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                component={inputField}
                name="email"
                maxLength="255"
                placeholder="Your Personal Email"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                className={`form-control ${styles['account-name']}`}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Mobile Phone Number<red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                component={PhoneNumberField}
                name="phone_number"
                type="tel"
                placeholder=""
                errorRegister
                showTextError
                customClassName={styles['account-name']}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Home Phone Number
            </label>
            <div className="col-sm-8">
              <Field
                component={PhoneNumberField}
                name="other_phone_number"
                type="tel"
                placeholder=""
                errorRegister
                showTextError
                customClassName={styles['account-name']}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              NIK<red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                component={inputField}
                name="nik"
                maxLength="16"
                placeholder="Your NIK"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                className={`form-control ${styles['account-name']}`}
                normalize={numberOnly()}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Gender
              <red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                name="gender"
                className={`form-control ${styles['bank-select']}`}
                id="gender"
                component={renderSelectField}
              >
                <option value="" key="">
                  Select Your Gender
                </option>
                {gender.map(option => (
                  <option value={option.value} key={option.value}>
                    {option.name}
                  </option>
                ))}
              </Field>
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Marital Status
              <red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                name="marital_status"
                className={`form-control ${styles['bank-select']}`}
                id="marital_status"
                component={renderSelectField}
              >
                <option value="" key="">
                  Select Your Marital Status
                </option>
                {maritalStatus.map(option => (
                  <option value={option.value} key={option.name}>
                    {option.name}
                  </option>
                ))}
              </Field>
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Place of Birth
              <red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                component={inputField}
                name="place_of_birth"
                maxLength="255"
                placeholder="Place of Birth"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                className={`form-control ${styles['account-name']}`}
                normalize={alphabeticalAndSomeChar()}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Date of Birth
              <red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                component={MokaDatePicker}
                name="birth_date"
                placeholder="YYYY-MM-DD"
                readOnly={false}
                showMonthDropdown
                showYearDropdown
                errorClassName={styles.error}
                className={`form-control ${styles['account-name']}`}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              KTP Address
              <red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                component={inputField}
                name="ktp_address"
                maxLength="255"
                placeholder="Your Personal Address"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                className={`form-control ${styles['account-name']}`}
                normalize={alphabeticalAndSomeChar()}
              />
            </div>
            <div className="col-sm-offset-4 col-sm-8">
              <Field
                component={inputField}
                name="ktp_city"
                maxLength="255"
                placeholder="City"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                className={`form-control ${styles['account-name']}`}
                normalize={alphabeticalAndSomeChar()}
              />
            </div>
            <div className="col-sm-offset-4 col-sm-8">
              <Field
                name="ktp_province"
                className={`form-control ${styles['bank-select']}`}
                id="business_location _id"
                component={renderSelectField}
              >
                <option key={0} value="">
                  Select Province...
                </option>
                {businessLocationsState.map(option => (
                  <option value={option.name} key={option.id}>
                    {option.name}
                  </option>
                ))}
              </Field>
            </div>
            <div className="col-sm-offset-4 col-sm-8">
              <Field
                component={inputField}
                name="ktp_zipcode"
                maxLength="5"
                placeholder="Zip"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                className={`form-control ${styles['account-name']}`}
                normalize={numberOnly()}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
              Home Address is the same as KTP Address?
            </label>
            <div className="col-sm-8">
              <label className={styles.option}>
                <Field
                  name="is_address_same_as_ktp"
                  component="input"
                  type="radio"
                  value
                />{' '}
                Yes
              </label>
              <label className={styles.option}>
                <Field
                  name="is_address_same_as_ktp"
                  component="input"
                  type="radio"
                  value={false}
                />{' '}
                No
              </label>
              <Field name="question_1" component={renderError} />
            </div>
          </div>
          {!capitalForm.is_address_same_as_ktp && (
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                Home Address
                <red>*</red>
              </label>
              <div className="col-sm-8">
                <Field
                  component={inputField}
                  name="address"
                  maxLength="255"
                  placeholder="Your Personal Address"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                  className={`form-control ${styles['account-name']}`}
                  normalize={alphabeticalAndSomeChar()}
                />
              </div>
              <div className="col-sm-offset-4 col-sm-8">
                <Field
                  component={inputField}
                  name="home_city"
                  maxLength="255"
                  placeholder="City"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                  className={`form-control ${styles['account-name']}`}
                  normalize={alphabeticalAndSomeChar()}
                />
              </div>
              <div className="col-sm-offset-4 col-sm-8">
                <Field
                  name="home_province"
                  className={`form-control ${styles['bank-select']}`}
                  id="business_location _id"
                  component={renderSelectField}
                >
                  <option key={0} value="">
                    Select Province...
                  </option>
                  {businessLocationsState.map(option => (
                    <option value={option.name} key={option.id}>
                      {option.name}
                    </option>
                  ))}
                </Field>
              </div>
              <div className="col-sm-offset-4 col-sm-8">
                <Field
                  component={inputField}
                  name="home_zipcode"
                  maxLength="5"
                  placeholder="Zip"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                  className={`form-control ${styles['account-name']}`}
                  normalize={numberOnly()}
                />
              </div>
            </div>
          )}

          <div className="form-group row">
            <label
              htmlFor="current_residence_ownership"
              className="col-sm-4 col-form-label"
            >
              Residence Ownership<red>*</red>
            </label>
            <div className="col-sm-8">
              <Field
                name="current_residence_ownership"
                className={`form-control ${styles['bank-select']}`}
                id="current_residence_ownership"
                component={renderSelectField}
              >
                <option value="" key="">
                  Select Your Residence Ownership
                </option>
                {residenceOwnership.map(option => (
                  <option value={option.name} key={option.name}>
                    {option.name}
                  </option>
                ))}
              </Field>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModalkuNewPersonalInfoForm;
